"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { switchMap, catchError, map } from "rxjs/operators";

import { requestTypes } from "../_constants";
import { lcvCampaignConstants } from "../_constants/lcvCampaign.constants";
import { lcvCampaignsGetComplete } from "../_actions/lcvCampaign.action";
import { ajaxError } from "../_actions";
import { getRequestHeader } from "../../_helpers/request.header";

// Every LCV call made from an epic carries the campaign selected in the dropdown. Reading it here
// rather than from each screen means a reload emitted by an epic, which has no screen behind it,
// still asks for the right campaign.
export const withLcvCampaign = (payload, state$) => ({
     ...(payload || {}),
     campaignId: state$?.value?.lcvCampaign?.selectedCampaignId ?? undefined,
});

export const lcvCampaignsGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(lcvCampaignConstants.LCV_CAMPAIGNS_GET_REQUEST),
          switchMap((incoming) =>
               ajax
                    .post("/api/lcvCampaigns/getCampaigns", incoming.payload || {}, getRequestHeader(requestTypes.REQUEST_TYPE_POST))
                    .pipe(
                         map((ajaxResponse) => lcvCampaignsGetComplete(ajaxResponse.response)),
                         catchError((error) => of(ajaxError(error))),
                    ),
          ),
     );
};
